import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "HtmlEditorRibbonStore"*/ './lazyIndex')
);

export type { default as RibbonFormatState } from './store/schema/RibbonFormatState';
export type { default as RibbonViewState } from './store/schema/RibbonViewState';

// Delay loaded actions
export let lazyUpdateRibbonWidth = new LazyAction(lazyModule, m => m.updateRibbonWidth);
export let lazySetLastTextColor = new LazyAction(lazyModule, m => m.setLastTextColor);
export let lazySetLastBackColor = new LazyAction(lazyModule, m => m.setLastBackColor);
export let lazyToggleFormatPainter = new LazyAction(lazyModule, m => m.toggleFormatPainter);
export let lazyUpdateRibbonState = new LazyAction(lazyModule, m => m.updateRibbonState);
export let lazyUpdateSecondClassState = new LazyAction(lazyModule, m => m.updateSecondClassState);
export let lazySetButtonWidths = new LazyAction(lazyModule, m => m.setButtonWidths);
